export default {
  formId: 'assistantsForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre del Asistente',
      requiredErrorMsg: 'El nombre es requerido',
    },
    description: {
      name: 'description',
      label: 'Descripción',
    },
    service_id: {
      name: 'service_id',
      label: 'Servicio IA',
      requiredErrorMsg: 'El servicio IA es requerido',
    },
    systemPrompt: {
      name: 'systemPrompt',
      label: 'System Prompt',
    },
    welcomeMessage: {
      name: 'welcomeMessage',
      label: 'Mensaje de Bienvenida',
    },
    temperature: {
      name: 'temperature',
      label: 'Temperatura (0 - 2)',
    },
    topP: {
      name: 'topP',
      label: 'Top P (0 - 1)',
    },
    maxTokens: {
      name: 'maxTokens',
      label: 'Máximo de Tokens',
    },
    avatar: {
      name: 'avatar',
      label: 'Avatar',
    },
    icon: {
      name: 'icon',
      label: 'Icono',
    },
    color: {
      name: 'color',
      label: 'Color',
    },
    visibility: {
      name: 'visibility',
      label: 'Visibilidad',
    },
    isPublic: {
      name: 'isPublic',
      label: 'Es Público',
    },
    allowHistory: {
      name: 'allowHistory',
      label: 'Permitir Historial',
    },
    allowImages: {
      name: 'allowImages',
      label: 'Permitir Imágenes',
    },
    allowAudio: {
      name: 'allowAudio',
      label: 'Permitir Audio',
    },
    allowFileUpload: {
      name: 'allowFileUpload',
      label: 'Permitir Subir Archivos',
    },
    maxMessagesPerDay: {
      name: 'maxMessagesPerDay',
      label: 'Máximo de Mensajes por Día',
    },
    maxContextMessages: {
      name: 'maxContextMessages',
      label: 'Máximo de Mensajes en Contexto',
    },
    assignedSkills: {
      name: 'assignedSkills',
      label: 'Habilidades (Skills)',
    },
  },
};
